import React  from 'react';
import { useDispatch } from 'react-redux';
import {
    toggleShowFullForm,
} from '../Actions/QuickSearch.action';
import magnifier from '../../images/magnifier.svg';


const QuickSearchButton = () => {
    const dispatch = useDispatch();
    
    return (
        <button className="quick-search__button" aria-label="Search button" onClick={() => dispatch(toggleShowFullForm())}>
            <img className="quick-search__button-icon" src={magnifier} alt="" />
            
        </button>
    );
};

export default QuickSearchButton;
